import { Trans } from '@lyearn/i18n';

import fieldValidate from '../../helper/fieldValidate';
import {
  Field,
  FieldType,
  FieldValidationFunction,
  FieldValidationTypes,
  FormPicklistField,
} from '../../types';
import { FieldInputType } from '../types';
import Input from './Input';

const fieldValidation: FieldValidationFunction = {
  [FieldValidationTypes.Required]: ({ value, validation }) => {
    if (!value) {
      return validation?.message || <Trans i18nKey="Form:FieldRequiredMessage" />;
    }
  },
  [FieldValidationTypes.Custom]: () => undefined,
};

const PicklistInputField: FieldInputType<FormPicklistField, string | string[]> = {
  Input,
  type: FieldType.Picklist,
  validate: (field, value, values) => {
    return fieldValidate({ field, value, values, fieldValidation });
  },
};

export default PicklistInputField;
